import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';
import Navigation from '@/components/Navigation';
import ServiceNavigation from '@/components/ServiceNavigation';

const EventsPage = () => {
  return (
    <>
      <Navigation />
      <div className="min-h-screen bg-gradient-to-br from-pearl-50/50 via-white to-ocean-25/30">
        {/* Service Navigation */}
        <div className="pt-20">
          <ServiceNavigation currentService="eventos" />
        </div>

        {/* Hero Section */}
        <motion.div
          className="relative py-16 px-4 sm:px-6 lg:px-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="max-w-4xl mx-auto text-center">
            <motion.div
              className="inline-flex items-center gap-3 mb-6"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <div className="w-16 h-16 bg-gradient-to-r from-jade-500 to-jade-600 rounded-2xl flex items-center justify-center text-white shadow-lg">
                <Calendar className="w-8 h-8" />
              </div>
              <div>
                <h1 className="text-4xl sm:text-5xl font-bold text-transparent bg-gradient-to-r from-jade-600 to-ocean-600 bg-clip-text font-heading">
                  Eventos Privados
                </h1>
              </div>
            </motion.div>
            
            <motion.p 
              className="text-xl text-deep-600 max-w-2xl mx-auto leading-relaxed mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              Experiencias gastronómicas únicas para eventos privados, bodas y celebraciones especiales 
              con nuestro Oyster Bar móvil.
            </motion.p>

            <motion.div
              className="bg-jade-50/50 rounded-2xl p-8 border border-jade-200/30"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <h3 className="text-2xl font-bold text-jade-700 mb-4">
                Página en Desarrollo
              </h3>
              <p className="text-jade-600 mb-6">
                Estamos trabajando en esta sección para ofrecerte la mejor información 
                sobre nuestros servicios de eventos privados.
              </p>
              <Link 
                to="/servicios"
                className="inline-flex items-center bg-gradient-to-r from-jade-500 to-jade-600 text-white px-6 py-3 rounded-xl font-semibold hover:opacity-90 transition-opacity"
              >
                Ver Todos los Servicios
              </Link>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default EventsPage;
